import { render, staticRenderFns } from "./MsNotification.vue?vue&type=template&id=79e7fda8&scoped=true&lang=html"
import script from "./MsNotification.vue?vue&type=script&lang=js"
export * from "./MsNotification.vue?vue&type=script&lang=js"
import style0 from "./MsNotification.vue?vue&type=style&index=0&id=79e7fda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7fda8",
  null
  
)

export default component.exports